import React, { useState } from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { Input } from '@/components/inputs'
import ErrorBoundary from '@/components/ErrorBoundary'

const EditPlainTextDialog = (props) => {
  const [text, setText] = useState(props.text)
  return (
    <React.Fragment>
      <BasicHeader title='Common.Description' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Input
            type='textarea'
            className='form-control'
            rows='5'
            style={{ width: '100%' }}
            onChange={e => setText(e.target.value)}
            value={text} />
        </ErrorBoundary>
      </ModalBody>
      <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={() => props.onAction(text)} />
    </React.Fragment>
  )
}

export default {
  component: EditPlainTextDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editPlainText.js